import { Box, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import React from 'react';
import Avatar from '../avatar/Avatar';
import { SimulationRole } from '../types';

export interface PositionProps {
  assignedStudentAvatar?: string;
  assignedStudentName?: string;
  assignedLayoutName?: string;
  classroomRole?: SimulationRole;
  name: string;
}

const Position = ({
  assignedStudentAvatar,
  assignedLayoutName,
  assignedStudentName,
  classroomRole,
  name,
}: PositionProps) => {
  return (
    <Box>
      <>
        <ListItem component="div" sx={{ height: 56 }} disablePadding>
          <ListItemAvatar sx={{ minWidth: 40 }}>
            <Avatar src={assignedStudentAvatar} />
          </ListItemAvatar>
          <ListItemText
            primary={assignedStudentName}
            primaryTypographyProps={{
              color: 'text.secondary',
              fontWeight: 'bold',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            secondary={classroomRole}
          />
        </ListItem>

        <Box display="flex" alignItems="center" gap={1} mt={1}>
          <Typography variant="h6">Position:</Typography> <Typography color="text.secondary">{name ?? '-'}</Typography>
        </Box>

        <Box display="flex" alignItems="center" gap={1} mt={1}>
          <Typography variant="h6">Layout:</Typography>{' '}
          <Typography color="text.secondary">{assignedLayoutName ?? '-'}</Typography>
        </Box>
      </>
    </Box>
  );
};

export default Position;
